<template>

    <div class="avatar-preview-container avatar-preview-container-prof" >

        <div class="avatar-preview user-avatar preview-full profs-photo  is-prof">
            <img :src="getProfImage " alt="Aperçu de l'avatar" class="avatar" v-if=" getProfImage !== '' "/>
        </div>


    </div>

</template>

<script>
export default {
    name : "PreviewAvatarProfs",
}
</script>

<script setup>

import { computed } from "vue";
import { useStore } from "vuex";

let props = defineProps( [ "field", "data", "datastore", "smallOnly" ] );
let store = useStore();

let user    = computed( () => store.state.user );
let profile = computed( () => user.value.profile );
let ready   = computed( () => user.value.ready );


let getProfImage = computed(() => profile?.value?.["profile-picture"] ?? '');


</script>

<style scoped>


</style>
